import React, { useCallback, useEffect, useState } from "react";
import { redirect, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import BookingDetailItem from "../booking/BookingDetailItem";
import BookingDetailItemIcon from "../booking/BookingDetailItemIcon";
import {
  resetInsuranceProviderView,
  viewInsuranceProvider,
} from "src/store/reducers/insuranceProviders";
import InsuranceProviderFormCanvas from "./InsuranceProviderFormCanvas";
import { Link } from "react-router-dom";

const ViewInsuranceProvider = () => {
  const dispatch = useAppDispatch();

  const { id: providerId } = useParams();

  const providerViewStatus = useAppSelector(
    (state) => state.insuranceProviders.view.status
  );
  const providerData = useAppSelector(
    (state) => state.insuranceProviders.view.data
  );
  const [editId, setEditId] = useState("");

  useEffect(() => {
    if (!providerId) {
      redirect("/insurance-providers");
    }
  }, [providerId]);

  const retry = useCallback(() => {
    dispatch(viewInsuranceProvider(providerId));
  }, [providerId, dispatch]);

  useEffect(() => {
    if (providerViewStatus === "idle") {
      retry();
    }
  }, [providerViewStatus, retry]);

  useEffect(() => {
    if (providerData?.id !== providerId) {
      dispatch(resetInsuranceProviderView());
    }
  }, [providerData?.id, providerId, dispatch]);

  return (
    <>
      <div className="container-fluid mh-auto">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                {providerViewStatus === "success" && providerData ? (
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                      <div className="about-me">
                        <ul>
                          <BookingDetailItemIcon
                            title={"Provider name"}
                            icon={"shield"}
                            value={providerData.provider_name}
                          />
                          <BookingDetailItemIcon
                            icon={"phone"}
                            title={"Contact number"}
                            value={providerData.contact_number}
                          />
                          <BookingDetailItemIcon
                            icon={"tag"}
                            title={"Provider code"}
                            value={providerData.provider_code}
                          />
                          <BookingDetailItemIcon
                            icon={"user-md"}
                            title={"Contact person"}
                            value={providerData.contact_person_name}
                          />
                        </ul>
                      </div>
                      <div className="d-flex mt-4 justify-content-end">
                        <Link
                          to={"#"}
                          onClick={() => setEditId(providerData.id)}
                          className="modal-btn btn btn-primary btn-sm ms-2"
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>
                          Edit
                        </Link>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9">
                      <div className="product-detail-content">
                        <div className="pr">
                          <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 c-details">
                              <ul>
                                <BookingDetailItem
                                  title={"Email"}
                                  value={providerData.email_id}
                                />
                                <BookingDetailItem
                                  title={"Notes"}
                                  value={providerData.notes}
                                />
                                <BookingDetailItem
                                  title={"Created"}
                                  value={new Date(
                                    providerData.created_date
                                  ).toLocaleString("en-IN")}
                                />
                                <BookingDetailItem
                                  title={"Updated"}
                                  value={new Date(
                                    providerData.updated_date
                                  ).toLocaleString("en-IN")}
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : providerViewStatus === "pending" ||
                  providerViewStatus === "idle" ? (
                  <div className="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div
                      className="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                ) : providerViewStatus === "error" ? (
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={retry}
                    >
                      Retry
                    </button>{" "}
                    &nbsp;
                    <strong onClick={retry}>Please try again </strong>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {providerData ? (
        <>
          <InsuranceProviderFormCanvas
            show={editId !== ""}
            hide={() => setEditId("")}
            editId={editId}
            Title={editId === "Add" ? "Add Insurance Provider" : "Edit Insurance Provider"}
            providerData={providerData}
          />
        </>
      ) : null}
    </>
  );
};

export default ViewInsuranceProvider;
